import React from "react"
import { Pagination } from "react-bootstrap"

export default function PaginationComponent({
	setProductPageNumber,
	productPageNumber,
	productsPageCount,
	currentItemsLength
}) {
	// Oculta todo si no hay nada para mostrar en la página actual
	if (!currentItemsLength || productsPageCount <= 1) return null

	const maxVisible = 5
	let start = Math.max(0, productPageNumber - 2)
	let end = Math.min(productsPageCount, start + maxVisible)

	if (end - start < maxVisible) {
		start = Math.max(0, end - maxVisible)
	}

	const visiblePages = []

	if (start > 0) {
		visiblePages.push(<Pagination.Ellipsis key="start-ellipsis" disabled />)
	}

	for (let i = start; i < end; i++) {
		visiblePages.push(
			<Pagination.Item
				className="pagination-item"
				key={i}
				active={i === productPageNumber}
				onClick={() => setProductPageNumber(i)}
			>
				{i + 1}
			</Pagination.Item>
		)
	}

	if (end < productsPageCount) {
		visiblePages.push(<Pagination.Ellipsis key="end-ellipsis" disabled />)
	}

	return (
		<div className="pagination-order pagination-all-tag">
			<Pagination>
				<Pagination.Prev
					onClick={() => setProductPageNumber(Math.max(0, productPageNumber - 1))}
					disabled={productPageNumber === 0}
				/>
				{visiblePages}
				<Pagination.Next
					onClick={() =>
						setProductPageNumber(
							Math.min(productsPageCount - 1, productPageNumber + 1)
						)
					}
					disabled={productPageNumber === productsPageCount - 1}
				/>
			</Pagination>
		</div>
	)
}
